import Vue from 'vue';

export const MAIN_LAYOUT_CONTAINER = 'body';
export const ADD_NEW_QUEUE = 'ADD_NEW_QUEUE';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const REMOVE_QUEUE = 'REMOVE_QUEUE';
export const CLOSE_ALL_NOTIFICATIONS = 'CLOSE_ALL_NOTIFICATIONS';

const notificationsStore = {
  namespaced: true,
  state () {
    return {
      queues: {}
    };
  },
  getters: {
    queues: (state) => state.queues,
    isExistingQueue (state) {
      return (container) => Object.keys(state.queues).some(key => key === container);
    }
  },
  mutations: {
    [ADD_NEW_QUEUE] (state, obj) {
      Vue.set(state.queues, obj.container, {
        layout: obj.layout,
        maxVisible: obj.maxVisible,
        notificationMaxId: 0,
        queue: []
      });
    },
    [ADD_NOTIFICATION] (state, notice) {
      if (state.queues[notice.container].maxVisible === 1 && state.queues[notice.container].queue.length === 1) {
        return;
      }

      const id = state.queues[notice.container].notificationMaxId;

      state.queues[notice.container].queue = [
        ...state.queues[notice.container].queue,
        {
          id,
          timeout: 5000,
          ...notice
        }
      ];

      Vue.set(state.queues[notice.container], 'notificationMaxId', id + 1);

      const length = state.queues[notice.container].queue.length;
      const maxVisible = state.queues[notice.container].maxVisible;

      if (length > maxVisible) {
        state.queues[notice.container].queue = state.queues[notice.container].queue.slice(length - maxVisible);
      }
    },
    [REMOVE_NOTIFICATION] (state, notice) {
      state.queues[notice.container].queue = state.queues[notice.container].queue.filter(n => n.id !== notice.id);
    },
    [REMOVE_QUEUE] (state, container) {
      const queue = state.queues[container];
      if (queue) {
        queue.layout.$destroy();
        queue.layout.$el.parentNode.removeChild(queue.layout.$el);
        delete state.queues[container];
      }
    },
    [CLOSE_ALL_NOTIFICATIONS] (state) {
      if (state.queues[MAIN_LAYOUT_CONTAINER]) {
        state.queues[MAIN_LAYOUT_CONTAINER].queue = [];
      }
    }
  }
};

export default notificationsStore;
